import React, { useEffect, useState, useMemo } from "react";
import { Table, Input, Button, Checkbox, Modal } from "antd";
import { useTableSearch } from "../tablas/useTableSearch";
import jsPDF from "jspdf";
import axios from "axios";
import "jspdf-autotable";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import { useMediaQuery } from "react-responsive";
import { DownloadOutlined, SearchOutlined, FilePdfOutlined, FileExcelOutlined } from "@ant-design/icons";
import { manejarError } from "../manejo_errores";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { InputCustom } from "../componentes/inputComponent";
import { exportToExcelGrupos } from "./exportToExcelGrupos";
const { Search } = Input;

export const TablaCompletaGrupos = ({
  fetchDatos,
  columns,
  elScroll,
  tituloPDF,
  gestionTabla,
  rowKey,
  mostrarBoton = true, // Por defecto, el botón de descarga está visible
  mostrarBuscador = true, // Por defecto, el buscador está visible
  filtrarUltimaColumna = true,
  mostrarFiltrador = false,
  filasPorPagina = 30,
  idAsociacion,
  tituloBanner = "",
  idCategoria,
  modoArmarGrupo,
  todosPilotos,
  textoDescarga,
  modoArmarGrupoTotales,
  pagination,         
  onPaginationChange,
  modoColorFondo,
  ordenSalida,
  mostrarInput = false,
  elvalueInput = "",
  onChangeInput = () => {},
  pilotoCubiertas,
  descargaExcel = false,
  subtituloBanner = "",
  camposConHistorial = [],
}) => {
  const MySwal = withReactContent(Swal);
  const [searchVal, setSearchVal] = useState(null);
  const { filteredData, loading } = useTableSearch({
    searchVal,
    retrieve: fetchDatos,
  });
  const [filtrosPilotos, setFiltrosPilotos] = useState({ desde: "", hasta: "" });
  const [pilotosSeleccionados, setPilotosSeleccionados] = useState([]);
  const [color, setColor] = useState("")
  const [modalDescarga, setModalDescarga] = useState(false);

  // console.log("lo q llega", fetchDatos)
  // console.log("id de la asociación", idAsociacion)

  const datosFiltradosPorOrden = useMemo(() => {
    let datos = [...filteredData];

    const desde = parseInt(filtrosPilotos.desde);
    const hasta = parseInt(filtrosPilotos.hasta);

    if (!isNaN(desde) && !isNaN(hasta)) {
      datos = datos.filter((item) => item.orden >= desde && item.orden <= hasta);
    }

    return datos;
  }, [filteredData, filtrosPilotos]);

  const hayAsterisco = useMemo(() => {
    if (!camposConHistorial || camposConHistorial.length === 0) return false;
    return camposConHistorial.some(({ key }) =>
      datosFiltradosPorOrden.some(
        (row) =>
          row?.[key] &&
          typeof row[key] === "object" &&
          Array.isArray(row[key].anteriores) &&
          row[key].anteriores.length > 0
      )
    );
  }, [camposConHistorial, datosFiltradosPorOrden]);

  const mensajeAsterisco = hayAsterisco
    ? "* indica el número anterior de motor antes del cambio declarado por el piloto en esa carrera."
    : "";

  const containerStyle = {
    width: "100%",
    maxWidth: "1200px",
    overflow: "auto",
  };

  const exportToPDF = async () => {
    const ahora = new Date();
    const fecha = `${ahora.getDate()}/${ahora.getMonth() + 1}/${ahora.getFullYear()}`;
    const hora = `${ahora.getHours()}:${ahora.getMinutes()}:${ahora.getSeconds()}`;

    const doc = new jsPDF();

    let datosParaExportar = [...datosFiltradosPorOrden];

    if (modoArmarGrupo) {
      if (pilotosSeleccionados.length === 0) {
        MySwal.fire({
					text: "Debes seleccionar al menos un piloto para generar el PDF.",
					icon: "warning",
					confirmButtonText: "Ok",
				})
        return;
      }

      // Filtrar los seleccionados
      const seleccionados = datosFiltradosPorOrden.filter((item) =>
        pilotosSeleccionados.includes(
          modoArmarGrupoTotales ? item.id : item.id_piloto
        )
      );

      if (modoArmarGrupoTotales == true) {
        // Ordenarlos por su orden original
        const seleccionadosOrdenados = [...seleccionados].sort(
          (a, b) => a.orden - b.orden
        );

        // Asignar nuevo orden del 1 en adelante
        datosParaExportar = seleccionadosOrdenados.map((piloto, index) => ({
          ...piloto,
          orden: index + 1,
        }));
      } else {
        datosParaExportar = [...seleccionados].sort(
          (a, b) => a.orden - b.orden
        );
      }
    }


    let startY = 50;
    if (mostrarBoton) {
      let asociacionesData;
      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/asociacion-detalles/${idAsociacion}`);

      if (response.status === 200) {
        asociacionesData = response.data;
        // console.log("asoc", asociacionesData)
      }
      // console.log("nombre", nombreCategoria)
      const nombreAsociacion = asociacionesData.nombre;
      const titulo = tituloBanner;
      const subtitulo = (subtituloBanner || "").trim();
      let nombreCategorias = "";
      if (idCategoria) {
        try {
          const responseCategoria = await axios.get(`${process.env.REACT_APP_DOMINIO}/categoria/${idCategoria}`);
          nombreCategorias = responseCategoria.data.categoria || "";
        } catch (error) {
          console.error("Error al obtener el nombre de la categoría", error);
        }
      }
      let logoUrl = asociacionesData.imagen && asociacionesData.imagen !== "null"
        ? `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${idAsociacion}/IMAGENES/ASOCIACIONES/${asociacionesData.imagen}`
        : "/img/logo-mundo-piloto.png";
      const getBase64Image = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      };
      let colorBase64 = null;

      if (modoColorFondo) {
        try {
          const responseCategoria = await axios.get(`${process.env.REACT_APP_DOMINIO}/categoria/${idCategoria}`);
          const colorFondo = responseCategoria.data.color_fondo;

          // console.log("res", colorFondo);

          if (colorFondo) {
            const urlColor = `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${idAsociacion}/IMAGENES/CATEGORIA/${colorFondo}`;
            colorBase64 = await getBase64Image(urlColor);
          } else {
            colorBase64 = null; // 👈 si no hay imagen, limpiamos el color
          }
        } catch (error) {
          console.error("Error al obtener color de fondo:", error);
          colorBase64 = null;
        }
      }

      const logoBase64 = await getBase64Image(logoUrl); 

      const pageWidth = doc.internal.pageSize.getWidth();

      // Fondo gris claro
      doc.setFillColor(220, 220, 220);
      doc.rect(10, 10, pageWidth - 20, 30, "F");

      // Logo izquierda
      doc.addImage(logoBase64, "PNG", 15, 13, 35, 24);

      // Escudo derecha
      if (colorBase64) {
        doc.addImage(colorBase64, "JPEG", pageWidth - 40, 12, 26, 26);
      }

      // Texto centrado
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(nombreAsociacion.toUpperCase(), pageWidth / 2, 20, { align: "center" });

      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(titulo.toUpperCase(), pageWidth / 2, 28, { align: "center" });

      let yLineaInferior = 35;
      if (subtitulo) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(subtitulo, pageWidth / 2, yLineaInferior, { align: "center" });
        yLineaInferior += 6;
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text(`${nombreCategorias.toUpperCase()}`, pageWidth / 2, yLineaInferior, { align: "center" });
      if (pilotoCubiertas) {
        doc.text(`${pilotoCubiertas}`, pageWidth / 2, yLineaInferior, { align: "center" });
      }

      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      const xMargen = pageWidth / 20;
      doc.text(`Fecha: ${fecha}`, xMargen, 46);

      // Cursor vertical debajo de la línea de fecha, usado tanto por el
      // aviso del asterisco como (si corresponde) por "Orden de salida".
      let yCursor = 52;

      if (camposConHistorial && camposConHistorial.length > 0) {
        const hayAsteriscoPDF = camposConHistorial.some(({ key }) =>
          datosParaExportar.some(
            (row) =>
              row?.[key] &&
              typeof row[key] === "object" &&
              Array.isArray(row[key].anteriores) &&
              row[key].anteriores.length > 0
          )
        );

        if (hayAsteriscoPDF) {
          const mensajeAsteriscoPDF =
            "* indica el número anterior de motor antes del cambio declarado por el piloto en esa carrera.";

          doc.setFont("helvetica", "italic");
          doc.setFontSize(11);
          doc.setTextColor(120, 120, 120);
          const anchoDisponible = pageWidth - xMargen * 2;
          const mensajeDividido = doc.splitTextToSize(mensajeAsteriscoPDF, anchoDisponible);
          doc.text(mensajeDividido, xMargen, yCursor);
          yCursor += mensajeDividido.length * 6 + 4;
          doc.setTextColor(0, 0, 0);
          doc.setFont("helvetica", "normal");
        }
      }

      startY = Math.max(startY, yCursor);

      if (ordenSalida && ordenSalida.length > 0) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);
        const yOrdenTitulo = yCursor + 4;
        doc.text(("Orden de salida").toUpperCase(), pageWidth / 2, yOrdenTitulo, { align: "center" });

        const textoCategorias = ordenSalida
          .map((c, index) => `${index + 1}°) ${c.categoria}`)
          .join("   "); // separador entre categorías

        // 🔽 Divide automáticamente el texto según el ancho disponible
        const textoDividido = doc.splitTextToSize(textoCategorias, pageWidth - 20);

        // 🔽 Escribe el texto en varias líneas (centrado)
        let y = yOrdenTitulo + 8;
        textoDividido.forEach((linea) => {
          doc.setFont("helvetica", "normal");
          doc.text(linea, pageWidth / 2, y, { align: "center" });
          y += 6; // espacio entre líneas
        });

        startY = y + 6;
      }
    }

    const filteredColumns = filtrarUltimaColumna ? columns.slice(0, -1) : columns;
    const columnHeaders = filteredColumns.map((col) =>
      typeof col.title === "function"
        ? col.title().props.children.props.children
        : col.title
    );

    // Antes de mapear para el PDF
    if (modoArmarGrupoTotales == true) {
      datosParaExportar = datosParaExportar.map((row, index) => ({
        ...row,
        orden_global: index + 1, // agrega orden numérico
      }));
    }

    const formattedData = datosParaExportar.map((row) =>
      filteredColumns.map((col) => {
        if (col.key === "orden") {
          if (modoArmarGrupoTotales == true) {
            return row.orden_global ? String(row.orden_global) : "-";
          } else {
            return row.orden ? String(row.orden) : "-";
          }
        }

        if (col.key === "motor") {
          const campo = row[col.key];
          if (campo && typeof campo === "object") {
            const numero = campo.numero ?? "-";
            const anteriores = Array.isArray(campo.anteriores) ? campo.anteriores : [];
            const sufijo = anteriores.map((a) => `[*${a}]`).join(" ");
            return sufijo ? `${numero} ${sufijo}` : `${numero}`;
          }
          return campo != null && campo !== "" ? String(campo) : "-";
        }

        let value = col.render
        ? col.render(row[col.dataIndex || col.key], row)
        : row[col.dataIndex || col.key];

    
        if (React.isValidElement(value)) {
          const children = React.Children.toArray(value.props.children);
          value = children.map((child) => {
            if (typeof child === "string" || typeof child === "number") {
              return String(child);
            }
            return "";
          }).join(" ");
        } else if (typeof value === "number") {
          value = String(value);
        } else if (typeof value === "object" && value !== null) {
          value = value.toString ? value.toString() : "";
        }
        // console.log(`valor de celda ${col.key}`, value, typeof value);
    
        return typeof value === "string" ? value : String(value);
      })
    );
    // console.log("DATA PARA PDF:", formattedData);

    // Detectar qué columnas contienen números para alinearlas a la derecha
    doc.autoTable({
      head: [columnHeaders],
      body: formattedData,
      startY: startY,
      styles: {
        fillColor: [255, 255, 255],
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [34, 52, 99],
        textColor: [255, 255, 255],
        cellPadding: 3,
        fontSize: 9, 
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
      columnStyles: {
        0: { minCellWidth: 18, halign: "center" },
        ...filteredColumns.reduce((styles, col, index) => {
          if (col.key === "motor") {
            // Más ancho fijo para que el vigente + cada "anterior" (una
            // línea por valor) entren sin cortarse ni desbordar.
            styles[index] = { cellWidth: 36, overflow: "linebreak", halign: "left" };
            return styles;
          }
          if (index === 0) return styles;
          const isNumericColumn = formattedData.every(
            (row) => !isNaN(row[index]) && row[index] !== " "
          );
          if (isNumericColumn) {
            styles[index] = { halign: "left" };
          }
          return styles;
        }, {}),
      },
      didParseCell: function (data) {
        if (data.section === "body") {
          const colKey = filteredColumns[data.column.index]?.key;
          if (colKey === "motor") {
            const record = datosParaExportar[data.row.index];
            const campo = record?.[colKey];
            const numero =
              campo && typeof campo === "object" ? campo.numero ?? "-" : campo ?? "-";
            const anteriores =
              campo && typeof campo === "object" && Array.isArray(campo.anteriores)
                ? campo.anteriores
                : [];

            // Una línea por valor (vigente primero) para que autoTable
            // reserve la altura de fila correcta antes de dibujar.
            data.cell.text = [String(numero), ...anteriores.map((a) => `[*${a}]`)];
            // La altura se calcula con la fuente del vigente (la más grande),
            // así sobra espacio para los "anteriores", que se dibujan más chicos.
            data.cell.styles.fontSize = 11;
          }
        }
      },
      willDrawCell: function (data) {
        if (data.section === "body") {
          const colKey = filteredColumns[data.column.index]?.key;
          if (colKey === "motor") {
            // Vaciamos el texto para que autoTable no dibuje el contenido
            // por defecto: lo dibujamos a mano en didDrawCell con estilos mixtos.
            data.cell.text = [];
          }
        }
      },
      didDrawCell: function (data) {
        if (data.section === "body") {
          const colKey = filteredColumns[data.column.index]?.key;
          if (colKey === "motor") {
            const record = datosParaExportar[data.row.index];
            const campo = record?.[colKey];
            if (campo && typeof campo === "object") {
              const { x, y, height } = data.cell;
              const docC = data.doc;
              const padding = data.cell.padding("left");
              const numero = campo.numero ?? "-";
              const anteriores = Array.isArray(campo.anteriores) ? campo.anteriores : [];
              const lineas = [String(numero), ...anteriores.map((a) => `[*${a}]`)];

              const scaleFactor = docC.internal.scaleFactor;
              const lineHeightFactor = docC.getLineHeightFactor();
              const lineHeight = (11 / scaleFactor) * lineHeightFactor;
              const bloqueAltura = lineas.length * lineHeight;
              let lineY = y + (height - bloqueAltura) / 2 + lineHeight / 2;

              lineas.forEach((linea, index) => {
                if (index === 0) {
                  docC.setFont("helvetica", "bold");
                  docC.setFontSize(11);
                  docC.setTextColor(0, 0, 0);
                } else {
                  docC.setFont("helvetica", "italic");
                  docC.setFontSize(9);
                  docC.setTextColor(140, 140, 140);
                }
                docC.text(linea, x + padding, lineY, { baseline: "middle" });
                lineY += lineHeight;
              });

              docC.setFont("helvetica", "normal");
              docC.setFontSize(9);
              docC.setTextColor(0, 0, 0);
            }
          }
        }

        if (data.section === "head") {
          const { cell, column, row } = data;
          const docC = data.doc;
          const radius = 6;

          // Primera celda (esquina superior izquierda)
          if (column.index === 0 && row.index === 0) {
            const { x, y, width, height } = cell;
            docC.setFillColor(34, 52, 99);
            docC.setDrawColor(34, 52, 99);

            docC.roundedRect(x, y, width, height, radius, radius, "F");
            docC.setTextColor(255, 255, 255);
            docC.text(cell.text[0], x + width / 2, y + height / 2, {
              align: "center",
              baseline: "middle",
            });
          }

          // Última celda (esquina superior derecha)
          if (
            column.index === row.cells.length - 1 &&
            row.index === 0
          ) {
            const { x, y, width, height } = cell;
            docC.setFillColor(34, 52, 99);
            docC.setDrawColor(34, 52, 99);

            docC.roundedRect(x, y, width, height, radius, radius, "F");
            docC.setTextColor(255, 255, 255);
            docC.text(cell.text[0], x + width / 2, y + height / 2, {
              align: "center",
              baseline: "middle",
            });
          }
        }
      },
      didDrawPage: (data) => {
        const pageCount = doc.internal.getNumberOfPages();
        doc.setFontSize(10);
        doc.text(`Página ${data.pageNumber} de ${pageCount}`, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10, {
          align: "right",
        });
      },
    });

    doc.save(`${tituloPDF}_${fecha.replace(/\//g, "-")}_${hora.replace(/:/g, "-")}.pdf`);
  };

  const exportToExcel = () => {
    exportToExcelGrupos({
      datosFiltradosPorOrden,
      modoArmarGrupo,
      pilotosSeleccionados,
      modoArmarGrupoTotales,
      MySwal,
      idAsociacion,
      idCategoria,
      tituloBanner,
      tituloPDF,
      columns,
      filtrarUltimaColumna,
      pilotoCubiertas,
    });
  };

  const esTelefono = useMediaQuery({ maxWidth: 768 });

  useEffect(() => {
    if (todosPilotos) {
      if (modoArmarGrupoTotales == true) {
        const todosLosIds = datosFiltradosPorOrden.map((item) => item.id);
        setPilotosSeleccionados(todosLosIds);
      } else {
        const todosLosIds = datosFiltradosPorOrden.map((item) => item.id_piloto);
        setPilotosSeleccionados(todosLosIds);
      }
    } else {
      setPilotosSeleccionados([]);
    }
  }, [todosPilotos, datosFiltradosPorOrden]);


  const columnasConCheck = useMemo(() => {
    if (!modoArmarGrupo) return columns;

    if (modoArmarGrupoTotales == true) {
      return [
        {
          title: "Seleccionar",
          key: "seleccionar",
          dataIndex: "id",
          width: 20,
          align: "center",
          render: (id_piloto) => (
            <Checkbox
              checked={pilotosSeleccionados.includes(id_piloto)}
              onChange={(e) => {
                setPilotosSeleccionados((prev) => {
                  if (e.target.checked) {
                    return [...prev, id_piloto];
                  } else {
                    return prev.filter((id) => id !== id_piloto);
                  }
                });
              }}
            />
          ),
        },
        ...columns,
      ];
    } else {
      return [
        {
          title: "Seleccionar",
          key: "seleccionar",
          dataIndex: "id_piloto",
          width: 20,
          align: "center",
          render: (id_piloto) => (
            <Checkbox
              checked={pilotosSeleccionados.includes(id_piloto)}
              onChange={(e) => {
                setPilotosSeleccionados((prev) => {
                  if (e.target.checked) {
                    return [...prev, id_piloto];
                  } else {
                    return prev.filter((id) => id !== id_piloto);
                  }
                });
              }}
            />
          ),
        },
        ...columns,
      ];
    }
  }, [modoArmarGrupo, columns, pilotosSeleccionados]);

  const handleSearchChange = (value) => {
    setSearchVal(value); // Actualiza el estado del buscador
  };
  return (
    <div style={containerStyle}>
      {/* Contenedor para los botones */}
      <div
        style={{
          display: "flex",
          flexDirection: "column", //
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <div>

        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            gap: "10px"
          }}
        >
          {/* Buscador (solo si mostrarBuscador es true) */}
          {mostrarBuscador && (
            <Search
              placeholder="Buscar en la tabla"
              allowClear
              enterButton={
                <Button
                  type="primary"
                  style={{
                    backgroundColor: "#223463",
                    fontSize: "17px",
                    color: "#fff",
                    borderRadius: "5px",
                    padding: "5px 10px",
                    marginLeft: "1em",
                    fontFamily: "system-ui"
                  }}
                >
                  {esTelefono ? <SearchOutlined /> : "Buscar"}
                </Button>
              }
              size="medium"
              onSearch={handleSearchChange}
              className="search"
              style={{
                maxWidth: "600px",
                // height: "2em",
                fontSize: "0.8em",
              }}
            />
          )}

          <div style={{ display: "flex", gap: "10px", marginTop: "0", width: mostrarInput ? "100%" : "none", justifyContent: mostrarInput ? "flex-end" : "none", justifyContent: mostrarInput ? "space-between" : "none" }}>
            {/* Botón para exportar a PDF (solo si mostrarBoton es true) */}
            {mostrarInput && (
              <InputCustom
                idCampo="nombre_grupo"
                nombreCampo="Nombre de grupo"
                tipo="text"
                elValue={elvalueInput || ""}
                elPlaceholder="Ingrese el nombre del grupo"
                onChange={onChangeInput}
                style={{
                  width: "100%",
                }}
              />
            )}
            {(mostrarBoton || gestionTabla) && (
              <>
                {mostrarBoton && (
                  <BotonPrincipal
                    onClick={() => {
                      if (descargaExcel) {
                        setModalDescarga(true);
                      } else {
                        exportToPDF();
                      }
                    }}
                    texto={
                      esTelefono
                        ? <DownloadOutlined />
                        : textoDescarga
                        ? textoDescarga
                        : "Descargar tabla"
                    }
                    Descargar
                    tabla
                  />
                )}
                {gestionTabla}
              </>
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            marginBottom: "1em",
            width: "100%",
            gap: "10px"
          }}
          >
          {mostrarFiltrador && (
            <>
              <input
                type="number"
                placeholder="Desde"
                className="input-form"
                value={filtrosPilotos.desde || ""}
                onChange={(e) =>
                  setFiltrosPilotos((prev) => ({
                    ...prev,
                    desde: e.target.value,
                  }))
                }
              />
              <input
                type="number"
                placeholder="Hasta"
                className="input-form"
                value={filtrosPilotos.hasta || ""}
                onChange={(e) =>
                  setFiltrosPilotos((prev) => ({
                    ...prev,
                    hasta: e.target.value,
                  }))
                }
              />
            </>
          )}
        </div>

        {descargaExcel && (
          <Modal
            open={modalDescarga}
            title="Descargar tabla"
            onCancel={() => setModalDescarga(false)}
            footer={null}
            centered
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: 12,
              }}
            >
              <Button
                type="primary"
                icon={<FilePdfOutlined />}
                onClick={() => {
                  setModalDescarga(false);
                  exportToPDF();
                }}
                style={{ 
                  backgroundColor: "#223463",
                  color: "#fff",
                  fontSize: 16,
                  width: "50%"
                }}
              >
                Descargar PDF
              </Button>

              <Button
                type="primary"
                icon={<FileExcelOutlined />}
                onClick={() => {
                  setModalDescarga(false);
                  exportToExcel();
                }}
                style={{ 
                  backgroundColor: "#1f7a3f",
                  color: "#fff",
                  fontSize: 16,
                  width: "50%"
                }}
              >
                Descargar Excel
              </Button>
            </div>
          </Modal>
        )}

        {mensajeAsterisco && (
          <div
            style={{
              fontSize: 12,
              color: "#777",
              fontStyle: "italic",
              marginBottom: 8,
            }}
          >
            {mensajeAsterisco}
          </div>
        )}

        <Table
          translate="no"
          className="notranslate"
          rowKey={rowKey ? rowKey : "id"}
          dataSource={datosFiltradosPorOrden}
          columns={columnasConCheck}
          loading={loading}
          scroll={elScroll}
          pagination={{
            ...pagination,
            showSizeChanger: false,
            pageSize: 30,
            onChange: onPaginationChange, // acá ejecuta la función del padre
          }}
          size="small"
          rowClassName={() => "custom-row"}
          style={{ width: "100%" }}
        />

        {/* <div style={{ display: "flex", flexDirection: "row", width: "100%", height: "100%", gap: 10 }}>
          <div style={{ width: 20, height: "100%", padding: "20px",
            border: "1px solid #bbbbbb",
            borderRadius: "10px" }}></div>
          {/* Tabla 
          <Table
            rowKey={rowKey ? rowKey : "id"}
            dataSource={datosFiltradosPorOrden}
            columns={columns}
            loading={loading}
            scroll={elScroll}
            pagination={{ position: ["bottomCenter"], pageSize: filasPorPagina }}
            size="small"
            rowClassName={() => "custom-row"}
            style={{ width: "100%" }}
          />
        </div> */}
      </div>
    </div>
  );
};
